module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.62046 2.35314C4.87477 2.20392 5.19291 2.21756 5.43352 2.38799L17.4335 10.888C17.7141 11.0868 17.8236 11.4509 17.6992 11.7714C17.5747 12.092 17.2482 12.2869 16.907 12.2442L9.48934 11.317L7.20002 17.2692C7.07567 17.5925 6.74608 17.7886 6.40262 17.7437C6.05916 17.6987 5.79118 17.4243 5.75428 17.0799L4.25428 3.07991C4.22287 2.78673 4.36615 2.50235 4.62046 2.35314ZM5.92281 4.57275L6.91488 13.8321L8.3 10.2308C8.42376 9.909 8.75094 9.71304 9.09304 9.7558L14.1287 10.3853L5.92281 4.57275Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
